"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.presentSocial = presentSocial;
var _solidUi = require("solid-ui");
var _rdfList = require("../shared/rdfList");
var _helpers = require("./helpers");
function presentSocial(subject, store) {
  function accountAsObject(ac) {
    return {
      name: (0, _helpers.nameForAccount)(store, ac),
      icon: (0, _helpers.iconForAccount)(store, ac),
      homepage: (0, _helpers.homepageForAccount)(store, ac),
      entryNode: ac
    };
  }

  // we need to load the social media accounts ontology to be able to query all data needed
  (0, _helpers.ensureSocialOntologyLoaded)(store);
  const accountNodes = store.each(subject, _solidUi.ns.foaf('account'));
  const accountThings = accountNodes.flatMap(node => (0, _rdfList.expandRdfList)(store, node));
  // Deduplicate by foaf:accountName value
  const accountNameSet = new Set();
  const accounts = [];
  for (const ac of accountThings) {
    if (ac.termType === 'NamedNode') {
      const accountNameNode = store.any(ac, _solidUi.ns.foaf('accountName'));
      const dedupeKey = accountNameNode ? accountNameNode.value : '';
      if (!accountNameSet.has(dedupeKey)) {
        accountNameSet.add(dedupeKey);
        accounts.push(accountAsObject(ac));
      }
    }
  }
  if (!accounts.length) return {
    accounts: []
  };
  return {
    accounts
  };
}